import React from 'react'
import MappingTabs from './MappingTabs'

const BookingTab = () => <MappingTabs />

export default BookingTab




// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/BookingTab.js